export default __webpack_public_path__ + "static/media/icraft.90c98fec.png";